import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import ConfirmationDailog from "../../../../../Component/Dailog/ConfirmationDailog";
import { DELETEONSPOTNEWFAQ } from "../../../../../Apis/new_on_spot_api";
import { useState } from "react";
import { ToastShow } from "../../../../../Component/Toast/Toast";
import AddUpdateNewOnSpotFaq from "../../../../../Component/Dailog/AddUpdateNewOnSpotFaq";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function FAQ({ getData, id, row }) {
  const [open, setOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const handleOpen = (v = null) => {
    setSelectedRow(v);
    setOpen(true);
  };

  const handleOnClose = (v) => {
    if (v) {
      getData();
    }
    setOpen(false);
  };

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [selectedId, setSelectedIdN] = useState(0);

  const onDelete = async (id) => {
    handleOpenConfirmation(id);
  };

  const handleOpenConfirmation = (id) => {
    setSelectedIdN(id);
    setOpenConfirmation(true);
  };

  const handleOnCloseConfirmation = async (v) => {
    if (v) {
      const r = await DELETEONSPOTNEWFAQ(selectedId);
      if (r && r.s) {
        getData();
        ToastShow("Deleted successfully");
      } else {
        ToastShow("Opps something went wrong. Please try again.");
      }
    }
    setSelectedIdN(0);
    setOpenConfirmation(false);
  };

  return (
    <>
      <Paper
        sx={{
          p: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "start",
          }}
        >
          <Typography variant="h5">Faq</Typography>
          <Button onClick={handleOpen}>Add Faq</Button>
        </Box>
        <Divider />

        {row.length ? (
          <Box
            sx={{
              flexDirection: "column",
              display: "flex",
              gap: "15px",
              p: 1,
              flexWrap: "wrap",
            }}
          >
            {row.map((v, index) => {
              return (
                <Box
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "start",
                    flexDirection: "column",
                  }}
                >
                  <Accordion
                  elevation={0}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>
                        {" "}
                        {index + 1}) {v.questions}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>{v.answer}</Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Box
                    sx={{
                      display: "flex",
                      mt: 1,
                      ml:2
                    }}
                  >
                    <Button
                      onClick={() => handleOpen(v)}
                      variant="outlined"
                      sx={{
                        borderRadius: "0px",
                        borderTopLeftRadius: "10px",
                        borderBottomLeftRadius: "10px",
                        flex: 1,
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={() => onDelete(v.id)}
                      variant="outlined"
                      sx={{
                        flex: 1,
                        borderRadius: "0px",
                        borderTopRightRadius: "10px",
                        borderBottomRightRadius: "10px",
                      }}
                    >
                      Delete
                    </Button>
                  </Box>

                  <Divider />
                </Box>
              );
            })}
          </Box>
        ) : (
          <Typography>Please add the faq by the "ADD FAQ" button</Typography>
        )}
      </Paper>

      {open ? (
        <AddUpdateNewOnSpotFaq
          row={selectedRow}
          handleOnClose={handleOnClose}
          open={open}
          on_spot_id={id}
        />
      ) : null}

      {openConfirmation ? (
        <ConfirmationDailog
          title="Delete faq !"
          content="Are you sure, You want to delete the faq?"
          open={openConfirmation}
          handleOnClose={handleOnCloseConfirmation}
        />
      ) : null}
    </>
  );
}

export default FAQ;
